"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var Swiper_1 = require("../Swiper/Swiper");

var ContentWithSwiper =
/** @class */
function (_super) {
  __extends(ContentWithSwiper, _super);

  function ContentWithSwiper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ContentWithSwiper.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        activeBreakpoint = _a.activeBreakpoint,
        slideWrapperStyle = _a.slideWrapperStyle,
        containerWidth = _a.containerWidth,
        containerHeightBase = _a.containerHeightBase,
        controlsEnabled = _a.controlsEnabled,
        controlsPressHandler = _a.controlsPressHandler;
    return react_1.default.createElement(SwiperContainer, {
      activeBreakpoint: activeBreakpoint,
      containerWidth: containerWidth,
      containerHeightBase: containerHeightBase
    }, react_1.default.createElement(Swiper_1.SwiperComponent, {
      slideWrapperStyle: slideWrapperStyle,
      controlsEnabled: controlsEnabled,
      controlsPressHandler: controlsPressHandler
    }, children));
  };

  return ContentWithSwiper;
}(react_1.default.Component);

var SwiperContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      containerWidth = _a.containerWidth,
      containerHeightBase = _a.containerHeightBase,
      rest = __rest(_a, ["activeBreakpoint", "containerWidth", "containerHeightBase"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    height: ", "px;\n"], ["\n    ", "\n    height: ", "px;\n"])), function (_a) {
  var containerWidth = _a.containerWidth;
  return containerWidth ? "width: " + containerWidth + "px;" : '';
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      containerHeightBase = _a.containerHeightBase;
  return setContainerHeight(activeBreakpoint, containerHeightBase);
});

function setContainerHeight(activeBreakpoint, containerHeightBase) {
  var extraLarge = responsive_1.isExtraLarge(activeBreakpoint);

  if (containerHeightBase) {
    return !extraLarge ? containerHeightBase : containerHeightBase * 1.125;
  }

  return 300;
}

exports.default = responsive_1.withResponsiveMeta(ContentWithSwiper);
var templateObject_1;